// Tells the server which time zone a datetime-local value was typed in, for
// forms where the server has no zone of its own to parse it with.
//
// - `zone` target (hidden input): set to the browser's IANA zone.
// - `label` target (optional): shows that zone's name.
// - `input` target + `instant` value (optional): a datetime-local input the
//   server rendered in its own zone; re-rendered here as the browser's local
//   wall time for the same instant.
//
// Usage:
//   <form data-controller="browser-time-zone" data-browser-time-zone-instant-value="2026-10-10T19:00:00Z">
//     <input type="hidden" name="form[time_zone]" data-browser-time-zone-target="zone">
//     <input type="datetime-local" data-browser-time-zone-target="input">
//   </form>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["zone", "label", "input"]
  static values = { instant: String }

  connect() {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!zone) return

    this.zoneTargets.forEach((target) => { target.value = zone })
    this.labelTargets.forEach((target) => { target.textContent = zone })
    if (this.instantValue && this.hasInputTarget) {
      this.inputTarget.value = this.localWallTime(this.instantValue)
      // Convert once: a Turbo cache restore reconnects, and must not clobber an edit.
      this.instantValue = ""
    }
  }

  localWallTime(instant) {
    const date = new Date(instant)
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16)
  }
}
